module.exports = __webpack_public_path__ + "static/media/img_familia.cb68fc10.jpg";